// Önerilen rotalar ve faturalar (B14–B16, B23–B24): yönlendirmeler (izin + bayrak korumalı, tembel yüklenir).
import { Route } from 'react-router';
import { guard, load } from '../../control/route-utils';

const Proposals = load(() => import('./Proposals'), 'Proposals');
const ProposalCompare = load(() => import('./ProposalCompare'), 'ProposalCompare');
const ProposalReview = load(() => import('./ProposalReview'), 'ProposalReview');
const Invoices = load(() => import('./Invoices'), 'Invoices');
const InvoiceDetail = load(() => import('./InvoiceDetail'), 'InvoiceDetail');

export const businessCommercialRoutes = (
  <>
    <Route path="teklifler" element={guard(Proposals, 'proposals')} />
    <Route path="teklifler/:id" element={guard(ProposalReview, 'proposals')} />
    <Route path="teklifler/:id/karsilastir" element={guard(ProposalCompare, 'proposals')} />
    <Route path="faturalar" element={guard(Invoices, 'finance', { flag: 'FINANCE' })} />
    <Route path="faturalar/:id" element={guard(InvoiceDetail, 'finance', { flag: 'FINANCE' })} />
  </>
);
